'use client';

import { PracticeModePicker } from '@/components/practice/practice-mode-picker';
import { PracticeInterface } from '@/components/practice/practice-interface';
import { useState } from 'react';

/**
 * Client shell that wires the mode picker to the practice interface.
 * Pulled out of the page file so page.js can remain a Server Component.
 */
export function PracticePageClient({ initialMode = 'free' }) {
  const [mode, setMode] = useState(initialMode);

  return (
    <div className="space-y-6">
      <PracticeModePicker mode={mode} onChange={setMode} hasWeakKeys={false} />
      <PracticeInterface key={mode} defaultMode={mode} />
    </div>
  );
}